import { jsx } from "react/jsx-runtime";
import { useState, useMemo } from "react";
import MuiTextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
function TextField({
  type = "text",
  showHideButton = false,
  margin = "0",
  maxWidth = "100%",
  error = false,
  select,
  SelectProps,
  children,
  sx = {},
  variant = "filled",
  ...props
}) {
  const [showInput, setShowInput] = useState(type !== "password");
  const typeMemo = useMemo(() => {
    if (!type)
      return void 0;
    if (type !== "password")
      return type;
    return showInput ? "text" : "password";
  }, [type, showInput]);
  const adornment = useMemo(() => {
    function handleClickShowInput() {
      return setShowInput(!showInput);
    }
    if (error && !select) {
      return /* @__PURE__ */ jsx(ErrorOutlineIcon, { color: "error" });
    }
    if (showHideButton) {
      return /* @__PURE__ */ jsx(InputAdornment, { position: "end", children: /* @__PURE__ */ jsx(IconButton, { "aria-label": "toggle password visibility", onClick: handleClickShowInput, sx: {
        mr: "-2px"
      }, edge: "end", children: showInput ? /* @__PURE__ */ jsx(VisibilityOff, {}) : /* @__PURE__ */ jsx(Visibility, {}) }) });
    }
    return void 0;
  }, [error, select, showHideButton, showInput]);
  return /* @__PURE__ */ jsx(MuiTextField, { variant, color: "secondary", error, type: typeMemo, fullWidth: true, sx: {
    maxWidth,
    margin,
    ...sx
  }, InputProps: {
    ...props.InputProps || {},
    // This will be either the visibility button or an error icon
    endAdornment: adornment,
    disableUnderline: true
  }, InputLabelProps: {
    ...props.InputLabelProps || {},
    variant,
    fontWeight: "500"
  }, select, SelectProps, ...props, children: !!select && children });
}
export {
  TextField
};
//# sourceMappingURL=index.js.map
